export default __webpack_public_path__ + "static/media/BRIGHTMOMENTS.5f02bb54.mp4";